import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@hotjar/hotsauce';
import PropTypes from 'prop-types';
import { withHighlight } from '../withHighlight';
import { EventsBinding } from './KeyboardShortcutEvents';

const PreviousBtn = ({ onClick, disabled }) => {
  const { t } = useTranslation();
  return (
    <IconButton
      size="s"
      icon="previous"
      tooltipText={t('common:player.previous-button')}
      description={t('common:player.previous-button')}
      kind="ghost"
      isDisabled={disabled}
      onClick={onClick}
      data-testid="recording-previous-button"
    />
  );
};

PreviousBtn.defaultProps = {
  disabled: false,
};

PreviousBtn.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export const PreviousButton = withHighlight(
  memo(PreviousBtn),
  EventsBinding.GO_TO_PREVIOUS_RECORDING,
);
